import api from '../utils/api';
import apiConstants from '../config/index';

export const getQuickInvoiceData = (invoiceID: string) => api.get(`${apiConstants.REACT_APP_API_URL}/v2/public/quickinvoice-data?developer-id=${apiConstants.REACT_APP_DEVELOPER_ID}&id=${invoiceID}&_format=json`, null);

export const submitPayment = (invoiceID: string, transaction: any) => api.post(`${apiConstants.REACT_APP_API_URL}/v2/public/quickinvoice?id=${invoiceID}`, { transaction });

export const getFile = (fileUri: string) => api.get(fileUri, 'blob').then((resp: any) => new Blob([resp.data], { type: resp.headers['content-type'] }));

// eslint-disable-next-line max-len
export function checkSurcharge(productTransactionId: string, cardNumber: string) {
  return new Promise((resolve, reject) => {
    try {
      const res = api.getSurcharge(`${apiConstants.REACT_APP_API_URL}/v2/public/surcharge?product_transaction_id=${productTransactionId}&cardNumber=${cardNumber}`);

      if (res) {
        resolve(res);
      } else {
        reject(res);
      }
    } catch (err) {
      reject(err);
    }
  });
}
// eslint-disable-next-line max-len
// export const checkSurcharge = (productTransactionId: string, cardNumber: string) => api.get(`${apiConstants.REACT_APP_API_URL}/v2/public/surcharge?developer-id=${apiConstants.REACT_APP_DEVELOPER_ID}&product_transaction_id=${productTransactionId}&cardNumber=${cardNumber}`, null);
